import { IconName } from '../pages/DesignSystem';

export interface NavItemConfig {
  icon: IconName;
  label: string;
  path: string;
}

export const PUBLIC_NAV_ITEMS: Record<string, NavItemConfig> = {
  explorer: {
    icon: 'Compass',
    label: 'Explorer',
    path: '/'
  },
  filter: {
    icon: 'Filter',
    label: 'Filters',
    path: '/filter'
  },
  favorites: {
    icon: 'Heart',
    label: 'Favorites',
    path: '/favorites'
  },
  menu: {
    icon: 'Menu',
    label: 'Menu',
    path: '/menu'
  }
};

export const ORGANIZER_NAV_ITEMS: Record<string, NavItemConfig> = {
  dashboard: {
    icon: 'BarChart',
    label: 'Dashboard',
    path: '/organizer/dashboard'
  },
  events: {
    icon: 'Calendar',
    label: 'Events',
    path: '/organizer/events'
  },
  profile: {
    icon: 'User',
    label: 'Profile',
    path: '/organizer/profile'
  },
  settings: {
    icon: 'Settings',
    label: 'Settings',
    path: '/organizer/settings'
  }
}; 